<template>
  <div class="main-container">
    <div class="input-container">
      <label class="text-center">Wybierz usługę</label>
      <select v-model="service_id" required class="form-control mb-5">
        <option disabled :value="null">Wybierz usługę</option>
        <option
          :value="service.id"
          v-for="service in services"
          :key="service.id"
          >{{ service.display_name }} - {{ service.description }}</option
        >
      </select>
      <div style="margin: 0 auto;">
        <div class="type-select">
          <input
            type="radio"
            :value="true"
            name="type"
            v-model="for_all"
            id="for_all"
          />
          <label for="for_all">Dla wszystkich</label>
        </div>
        <div class="type-select">
          <input
            type="radio"
            :value="false"
            v-model="for_all"
            name="type"
            id="for_user"
          />
          <label for="for_user">Dla konkretnego użytkownika</label>
        </div>
      </div>
    </div>
    <form class="topform mt-5" @submit.prevent="addLongDistanceService($event)">
      <div class="multiple-inputs">
        <div class="input-container">
          <label>Promień świadczenia usługi</label>
          <input
            v-model="radius"
            id="name"
            class="form-control"
            type="number"
            required
            minlength="1"
          />
        </div>
        <div class="input-container" v-if="!for_all">
          <label>Numer telefonu użytkownika</label>
          <input
            v-model="user_phone"
            id="displayName"
            type="number"
            class="form-control"
            required
            minlength="1"
          />
        </div>
      </div>
      <button
        v-if="((!for_all && user_phone) || for_all) && service_id && radius"
        class="buttonm btn btn-outline-dark"
        type="submit"
      >
        Zapisz
      </button>
    </form>
    <table
      class="table table-striped table-sm serviceTable"
      v-if="this.longDistanceServices && this.longDistanceServices.length > 0"
    >
      <thead>
        <tr class="tr-table">
          <th scope="col">ID</th>
          <th scope="col">Nr tel. użytkownika</th>
          <th scope="col">ID usługi</th>
          <th scope="col">Nazwa usługi</th>
          <th scope="col">Promień</th>
          <th scope="col">Edycja</th>
          <th scope="col">Usuń</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in longDistanceServices" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.user ? item.user.phone : "Dla wszystkich" }}</td>
          <td>{{ item.service.id }}</td>
          <td>
            {{ item.service.display_name }} - {{ item.service.description }}
          </td>
          <td>{{ item.radius }}</td>
          <td>
            <button
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              data-target="#editModal"
              @click="setLongDistanceServicesToEdit(item)"
            >
              Edytuj
            </button>
          </td>
          <td>
            <button
              class="btn btn-outline-dark"
              @click="deleteLongDistanceService(item)"
            >
              x
            </button>
          </td>

          <div
            class="modal fade"
            id="editModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="editModal"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="editModalLabel">
                    Edytuj usługę
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div class="input-container">
                    <label class="text-center">Wybierz usługę</label>
                    <select
                      v-model="service_id_to_edit"
                      required
                      class="form-control mb-5"
                    >
                      <option disabled :value="null">Wybierz usługę</option>
                      <option
                        :value="service.id"
                        v-for="service in services"
                        :key="service.id"
                        >{{ service.display_name }}
                        {{ service.description }}</option
                      >
                    </select>
                  </div>
                  <form
                    class="topform mt-5"
                    @submit.prevent="editLongDistanceService($event)"
                  >
                    <div class="multiple-inputs">
                      <div class="input-container">
                        <label>Promień świadczenia usługi</label>
                        <input
                          v-model="radius_to_edit"
                          id="name"
                          class="form-control"
                          type="number"
                          required
                          minlength="1"
                        />
                      </div>
                      <div class="input-container" v-if="!for_all_to_edit">
                        <label>Numer telefonu użytkownika</label>
                        <input
                          v-model="user_phone_to_edit"
                          id="displayName"
                          type="number"
                          class="form-control"
                          required
                          minlength="1"
                        />
                      </div>
                    </div>
                    <button
                      v-if="
                        ((!for_all_to_edit && user_phone_to_edit) ||
                          for_all_to_edit) &&
                          service_id_to_edit
                      "
                      class="buttonm btn btn-outline-dark"
                      type="submit"
                      :disabled="
                        (!user_phone_to_edit && !for_all_to_edit) ||
                          !service_id_to_edit ||
                          !radius_to_edit
                      "
                    >
                      Zapisz
                    </button>
                  </form>
                </div>

                <div class="modal-footer">
                  <button
                    id="editModalCloseButton"
                    type="button"
                    class="btn btn-outline-dark"
                    data-dismiss="modal"
                  >
                    Zamknij
                  </button>
                </div>
              </div>
            </div>
          </div>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
//import shared from "../../shared";
export default {
  name: "LongDistanceServices",
  data() {
    return {
      user_phone: "",
      service_id: "",
      radius: "",
      user_phone_to_edit: "",
      service_id_to_edit: "",
      radius_to_edit: "",
      long_distance_service_it_to_edit: "",
      for_all: true,
      for_all_to_edit: true,
    };
  },
  created() {
    this.$store.dispatch("getAllLongDistanceServices");
    this.$store.dispatch("getAllServices");
  },
  methods: {
    setLongDistanceServicesToEdit(item) {
      this.long_distance_service_it_to_edit = item.id;
      this.user_phone_to_edit = item.user ? item.user.phone : "";
      this.service_id_to_edit = item.service.id;
      this.radius_to_edit = item.radius;
      this.for_all_to_edit = item.for_all;
    },
    async editLongDistanceService() {
      if (this.for_all_to_edit) {
        this.user_phone = null;
      }
      const response = await this.$store.dispatch("editLongDistanceService", {
        id: this.long_distance_service_it_to_edit,
        user_phone:
          this.user_phone_to_edit && this.user_phone_to_edit !== ""
            ? this.user_phone_to_edit
            : null,
        service_id: this.service_id_to_edit,
        radius: this.radius_to_edit,
      });
      if (response === "not_found_user") {
        this.$notify({
          group: "error",
          text: "Nie ma użytkownika o takim numerze telefonu",
        });
      }
      if (response === true) {
        document.getElementById("editModalCloseButton").click();
        this.$notify({
          group: "success",
          text: "Pomyślnie edytowano usługę",
        });
      }
    },
    async addLongDistanceService() {
      if (this.for_all) {
        this.user_phone = null;
      }
      const response = await this.$store.dispatch("addLongDistanceService", {
        user_phone:
          this.user_phone && this.user_phone !== "" ? this.user_phone : null,
        service_id: this.service_id,
        radius: this.radius,
      });
      if (response === "not_found_user") {
        this.$notify({
          group: "error",
          text: "Nie ma użytkownika o takim numerze telefonu",
        });
      }
      if (response === true) {
        this.$notify({
          group: "success",
          text: "Pomyślnie dodano usługę",
        });
        this.user_phone = "";
        this.service_id = "";
        this.radius = "";
      }
    },
    async deleteLongDistanceService(service) {
      const confirmed = prompt(
        `Czy na pewno chcesz usunąć tą usługę z usług niestandardowych? Potwierdź wpisując 'TAK'`,
        ""
      );
      if (confirmed === "TAK") {
        await this.$store.dispatch("deleteLongDistanceService", {
          id: service.id,
        });
        this.$notify({
          group: "success",
          text: "Pomyslnie usunięto usługę",
        });
      }
    },
  },
  computed: {
    services() {
      return this.$store.getters.getAllServices;
    },
    longDistanceServices() {
      return this.$store.getters.getAllLongDistanceServices;
    },
  },
};
</script>

<style scoped>
div.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
button.btn {
  margin-top: 20px;
}
div.input-container {
  flex-direction: column;
  display: flex;
  margin-top: 10px;
}
.multiple-inputs {
  display: flex;
  justify-content: center;
}
.input-container {
  flex: 1;
  font-size: 15px;
}
.input-container label {
  font-size: 15px;
}

.main-container {
  margin: 0 auto;
  max-width: 1000px;
}

.main-container .form-control {
  margin: 0 auto;
  max-width: 400px;
}
.newCategoryForm {
  margin-bottom: 50px;
}
.newCategoryForm div input,
.newCategoryForm div textarea,
.form-control,
.newCategoryForm button {
  width: 400px;
  margin: 0;
}

img {
  max-height: 20px;
  height: 100%;
  width: auto;
}
.iconImg {
  width: 130px;
  max-height: 130px;
  padding: 25px;
}

.iconModal {
  background: #090741;
  color: white;
  outline: #fb8928;
}
.iconLink {
  margin-bottom: 6px;
  background: white;
  border-radius: 4px;
  border: 1px solid grey;
  width: 40px;
  margin: 3px;
  background: #090741;
  color: white;
}
.iconLink img {
  color: white;
  margin: 0 auto;
}
.iconLink:hover {
  color: #fb8928;
  cursor: pointer;
}
.inputButtonLabel {
  cursor: pointer;
}
.inputButtonLabel:hover {
  background: rgb(49, 45, 45);
  color: white;
}
.serviceTable:hover,
tr:hover {
  cursor: default !important;
}
div.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-top: 3%;
  margin-bottom: 20px;
}

.input-container label {
  margin: 10px 0px 0px 0px;
}
.inputButtonLabel {
  padding: 5px;
  border-radius: 5px;
}
.type-select label {
  margin-left: 1rem;
}
</style>
